// import external dependencies
import 'jquery';

// import local dependencies
import Router from './util/Router';
import common from './routes/mhpa/common';
import bcDashboard from './routes/mhpa/01-dashboard';
import bcSavings from './routes/mhpa/02-savings';
import bcSavingsDetail from './routes/mhpa/03-savings-detail';
import bcGraphs from './routes/mhpa/04-graphs';
import bcGraphsDaily from './routes/mhpa/05-graphs-daily';
import bcGraphsHourly from './routes/mhpa/06-graphs-hourly';
import bcSettings from './routes/mhpa/07-settings';
import template13MhpaRewards from './routes/mhpa/08-rewards';

// import everything from MHPA autoload
import './routes/mhpa/autoload/jquery.cookie.js';

/** Populate Router instance with DOM routes. Routes should contain a specific class name from the body class. See ./assets/util/Router.json for more. */
const routes = new Router({
  // All MHPA Pages
  common,
  // Dashboard page, note the change from bc-dashboard to bcDashboard.
  bcDashboard,
  // Savings & Savings Detail pages
  bcSavings,
  // Savings Detail page
  bcSavingsDetail,
  // Graphs pages
  bcGraphs,
  // Daily Graphs page
  bcGraphsDaily,
  // Hourly Graphs page
  bcGraphsHourly,
  // Settings page
  bcSettings,
  // Rewards pages
  template13MhpaRewards,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
